import { SalesOrder } from '@spa/services/api/purchase'
import { MutationTree } from 'vuex'
import { log } from '../../../log'
import { PurchaseState } from './types'

const namespace = 'orderHistory'

export const mutations: MutationTree<PurchaseState> = {

  listLatest(state, payload: SalesOrder) {
    state.error.load = null
    state.latestItem = payload

    log.debug({ commit: `${namespace}/listLatest`, state })
  },

  errorOnLoad(state, payload: Error) {
    const error = payload
    state.error.load =  error
  },

}
